'use client';

import PageTab from '@pc/components/molecules/tab/PageTab';
import PageTabsContainer from '@pc/components/molecules/tab/PageTabsContainer';
import { useRouter } from 'next/navigation';

function CustomerGuideTabsContainer() {
  const router = useRouter();
  return (
    <PageTabsContainer className='mb-6' contentClassName='w-[1280px]'>
      <PageTab includedURLPath='/guide/pc' onClick={() => router.push(`/customer/guide/pc/external`)}>
        PC
      </PageTab>
      <PageTab includedURLPath='/guide/mobile' onClick={() => router.push(`/customer/guide/mobile/camera`)}>
        모바일
      </PageTab>
    </PageTabsContainer>
  );
}

export default CustomerGuideTabsContainer;
